import { FormControl, TextField, Typography } from "@mui/material";
import React from "react";
import MaskedInput from "react-text-mask";
import Dialog from "../Dialog";
import styles from "./styles";
import { FieldMetaState, FieldRenderProps } from "react-final-form";

export interface IOwnProps {
  input?: any;
  meta: FieldMetaState<string>;
  onChange?(value: string): void;
  label?: string;
  required?: boolean;
  type?: string;
  size?: number;
  maxLength?: number;
  max?: number;
  min?: number;
  disabled?: boolean;
  mask?: any[];
  note?: string;
  imageHelpInfo?: ImageBitmap | any;
  classNote?: any;
  numberAfterDecimal?: number;
  multiline?: boolean;
  rows?: number;
  placeholder?: string;
}

const TextMaskCustom: React.FC<any> = ({ inputRef, mask, ...other }) => (
  <MaskedInput
    {...other}
    ref={(ref) => {
      inputRef && inputRef(ref ? ref.inputElement : null);
    }}
    mask={mask}
    guide={false}
    showMask
  />
);

const InputField: React.FC<
  IOwnProps & FieldRenderProps<any, HTMLElement, any>
> = ({
  input,
  meta: { error, touched },
  label,
  required = false,
  type = "text",
  size,
  maxLength,
  max,
  min = 0,
  disabled = false,
  mask,
  note,
  imageHelpInfo,
  classNote,
  placeholder,
  multiline = false,
  rows,
  numberAfterDecimal,
  onChange,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let val: any = event.target.value;

    if (
      val &&
      type === "number" &&
      numberAfterDecimal !== undefined &&
      Number.isInteger(Number(val))
    ) {
      val = Number(val).toFixed(numberAfterDecimal);
    }
    if (val && max && type === "number" && Number(val) > max) {
      val = max;
    }
    if (val && type === "number" && Number(val) < min) {
      val = min;
    }
    if (input) {
      input.onChange(val);
    }
    if (onChange) {
      onChange(val as string);
    }
  };

  return (
    <FormControl sx={styles} className="root">
      <TextField
        {...input}
        disabled={disabled}
        label={label}
        error={touched && !!error}
        multiline={multiline}
        placeholder={placeholder}
        rows={rows}
        required={required}
        className={"textFieldRoot"}
        InputProps={{
          classes: {
            input: "textField",
            underline: "underline",
          },
          inputComponent: mask ? TextMaskCustom : undefined,
        }}
        inputProps={{ size, maxLength, min, max, mask }}
        onChange={handleChange}
        InputLabelProps={{
          classes: {
            root: "textFieldLabel",
            focused: "textFieldLabelFocused",
            error: "textFieldLabelError",
            asterisk: "textFieldLabelAsterisk",
          },
        }}
        variant="filled"
        type={type}
        max={max}
      />
      {imageHelpInfo && <Dialog image={imageHelpInfo} />}
      {note && (
        <Typography
          className={`caption ${classNote || ""}`}
          variant="caption"
          dangerouslySetInnerHTML={{ __html: note }}
        />
      )}
      {error && touched && (
        <Typography color="error" variant="caption">
          {error}
        </Typography>
      )}
    </FormControl>
  );
};

export default InputField;
